(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["goaldrip-home"] && !Shopify.designMode) return;
  try {
    
(()=>{const r=document.currentScript.closest('.gdv2');if(!r||matchMedia('(prefers-reduced-motion:reduce)').matches)return;r.querySelectorAll('[data-tilt]').forEach(e=>{e.addEventListener('pointermove',a=>{const b=e.getBoundingClientRect(),x=(a.clientX-b.left)/b.width-.5,y=(a.clientY-b.top)/b.height-.5;e.style.transform='perspective(900px) rotateX('+(-y*7)+'deg) rotateY('+(x*7)+'deg) translateY(-5px)'});e.addEventListener('pointerleave',()=>e.style.transform='')})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
